import { DropdownMenu } from '@octopus-do/octopus-storybook'
import {
  AngleDown,
  ArrowUpArrowDown,
} from '@octopus-do/octopus-storybook/icons'
import { forwardRef } from 'react'

import { clsJoin } from '@/utils'
import css from './styles.module.css'

interface Props {
  title: string
}

export const SortButton = forwardRef<HTMLButtonElement, Props>(
  ({ title }, ref) => {
    const { active, open } = DropdownMenu.useTrigger()

    const className = clsJoin(css.sort_button, active && css.active)

    return (
      <button ref={ref} onClick={open} className={className}>
        <ArrowUpArrowDown className={css.up_down} />
        <div className={css.value_title}>
          {title} <AngleDown />
        </div>
      </button>
    )
  }
)
